<template>
  <div>
      <v-autocomplete
              v-model="input"
              :items="siteTypes"
              class="m-1"
              dense
              v-if="others"
              :rules="rules"
              item-text="keyAlias"
              item-value="key"
              :error-messages="errors !== undefined ? errors : []"
              label="سایز لوگو درخواستی"
              hint="لطفا سایز درخواستی خود را انتخاب یا وارد نمایید."
              placeholder="لطفا سایز درخواستی خود را انتخاب یا وارد نمایید."
              outlined
              :return-object="return_object"
      >
          <template v-slot:prepend-item>
              <v-list-item
                      ripple
                      @mousedown.prevent
                      @click="others = false"
              ><v-list-item-action>
                      <p>واردکردن سایز لوگو دلخواه</p>
                  </v-list-item-action>
              </v-list-item>
          </template>
      </v-autocomplete>
      <v-text-field
              v-if="!others"
              label="سایز لوگو درخواستی"
              hint="لطفا سایز درخواستی خود را انتخاب یا وارد نمایید."
              placeholder="لطفا سایز درخواستی خود را انتخاب یا وارد نمایید."
              dense
              v-model="input"
              outlined
              prepend-inner-icon="fa fa-pencil-alt"
              clear-icon="mdi-close-circle-outline"
              clearable
              @click:clear="others=true"
      ></v-text-field>
  </div>
</template>

<script>

export default {
    props: ['value', 'errors', 'dense', 'return_object'],

    data() {
        return {
            input: this.null,
            others: true,
            rules: [
                (value) => !!value || "وارد کردن این فیلد الزامی است.",
            ],
            siteTypes: [
                {key: '1000 * 1000', keyAlias: '1000 * 1000: اینستاگرام'},
                {key: '1640 * 624', keyAlias: '1640 * 624 :فیسبوک'},
                {key: '1000 * 1080', keyAlias: '1080 * 1000 :لینک دین'},
                {key: '800 * 800', keyAlias: '800 * 800 :یوتیوب'},
            ],

        }
    },
    name: "siteSelect",
    created() {
        this.input = this.value
    },
    watch: {
        input() {
            this.$emit('input', this.input)
        }
    }
}
</script>

<style scoped>

</style>